// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fields .field[data-v-1981e72c]{margin-top:0;margin-bottom:8px}.fields[data-v-1981e72c] label{font-size:.9em;padding:0 !important;padding-left:5px !important}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
